import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-8 px-2 md:px-4" }
const _hoisted_2 = { class: "flex md:flex-row gap-3 items-center justify-between mt-6 flex-col px-2 w-full" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row md:items-center w-full gap-3" }
const _hoisted_4 = { class: "flex flex-row items-center gap-1" }
const _hoisted_5 = { class: "w-full md:w-auto" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row gap-2 w-full md:w-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Agenda = _resolveComponent("Agenda")!
  const _directive_role = _resolveDirective("role")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("calendar.title")), 1),
    _createVNode(_component_Agenda, {
      formVisible: _ctx.formVisible,
      "onUpdate:formVisible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formVisible) = $event))
    }, {
      header: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                name: "co-filter",
                scale: 1.4
              }, null, 8, ["scale"]),
              _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t("calendar.visualize.label")), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedCourse.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCourse.id) = $event)),
                options: _ctx.courses,
                optionLabel: "name",
                optionValue: "id",
                onChange: _ctx.onSelectCourse,
                placeholder: 
                  _ctx.$t('calendar.visualize.autocomplete.course.placeholder')
                ,
                onClear: _ctx.clearInputCourse,
                filter: "",
                onFilter: _ctx.searchByCourseName,
                showClear: "",
                filterPlaceholder: 
                  _ctx.$t('labels.generic', {
                    pt: 'Pesquisar curso',
                    en: 'Search course',
                  })
                ,
                emptyFilterMessage: 
                  _ctx.$t('labels.generic', {
                    pt: 'Nenhum curso encontrado',
                    en: 'No course found',
                  })
                ,
                emptyMessage: 
                  _ctx.$t('labels.generic', {
                    pt: 'Nenhum curso encontrado',
                    en: 'No course found',
                  })
                
              }, null, 8, ["modelValue", "options", "onChange", "placeholder", "onClear", "onFilter", "filterPlaceholder", "emptyFilterMessage", "emptyMessage"]),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedClass.id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedClass.id) = $event)),
                options: _ctx.classes,
                optionLabel: "name",
                optionValue: "id",
                onChange: _ctx.onSelectClass,
                placeholder: 
                  _ctx.$t('calendar.visualize.autocomplete.class.placeholder')
                ,
                onClear: _ctx.clearInputClass,
                filter: "",
                onFilter: _ctx.searchByClassName,
                showClear: "",
                filterPlaceholder: 
                  _ctx.$t('labels.generic', {
                    pt: 'Pesquisar turma',
                    en: 'Search class',
                  })
                ,
                emptyFilterMessage: 
                  _ctx.$t('labels.generic', {
                    pt: 'Nenhuma turma encontrada',
                    en: 'No class found',
                  })
                ,
                emptyMessage: 
                  _ctx.$t('labels.generic', {
                    pt: 'Nenhuma turma encontrada',
                    en: 'No class found',
                  })
                
              }, null, 8, ["modelValue", "options", "onChange", "placeholder", "onClear", "onFilter", "filterPlaceholder", "emptyFilterMessage", "emptyMessage"])
            ])
          ]),
          _createVNode(_component_Button, {
            icon: "pi pi-plus",
            label: _ctx.$t('calendar.visualize.buttons.add'),
            class: "btn btn-primary w-full md:w-[220px]",
            onClick: _withModifiers(_ctx.addClass, ["prevent"])
          }, null, 8, ["label", "onClick"])
        ])), [
          [_directive_role, ['TEACHER', 'ADMINISTRATOR', 'APPLICATION_ADMIN']]
        ])
      ]),
      _: 1
    }, 8, ["formVisible"])
  ]))
}